import { useQuery } from '@tanstack/react-query'
import { notificationsApi } from '../lib/api'

export const notificationsQueryKey = ['notifications']

export function useNotifications(params = {}) {
  return useQuery({
    queryKey: [...notificationsQueryKey, params],
    queryFn: () => notificationsApi.list(params).then(res => res.data),
  })
}
